angular.module('dpw.components').component('dpwInstallToTeam', {
    templateUrl: 'dpw-install-to-team.component.html',
    controllerAs: 'ctrl',
    bindings: {
        application: '<',
        canManipulateApp: '<',
    },
    controller: ['applicationService', 'api', '$q', 'installMnaService',
        function (applicationService, api, $q, installMnaService) {
            var self = this;

            self.installUnavailableReason = null;

            self.UNAVAILABLE_REASONS = {
                HIPAA_ACCOUNT: 'HIPAA_ACCOUNT',
                INACTIVE_APP: 'INACTIVE_APP',
                PUBLIC_APP: 'PUBLIC_APP'
            };

            self.$onInit = function () {
                self.refreshStatus();
            };

            self.$onChanges = function (changes) {
                if (changes.application && !changes.application.isFirstChange() && !angular.equals(changes.application.previousValue, changes.application.currentValue)) {
                    self.refreshStatus();
                }
            }

            self.refreshStatus = function () {
                $q.all([
                    checkIsHipaa()
                ]).then(function (results) {
                    var isHipaa = results[0];

                    if (isHipaa) {
                        self.installUnavailableReason = self.UNAVAILABLE_REASONS.HIPAA_ACCOUNT;
                        return;
                    }

                    if (!applicationService.isActiveApp(self.application)) {
                        self.installUnavailableReason = self.UNAVAILABLE_REASONS.INACTIVE_APP;
                        return;
                    }

                    if (applicationService.isPublicApp(self.application)) {
                        self.installUnavailableReason = self.UNAVAILABLE_REASONS.PUBLIC_APP;
                        return;
                    }

                    self.installUnavailableReason = null;
                });
            };

            self.installButtonDisabled = function () {
                return _.includes([
                    self.UNAVAILABLE_REASONS.HIPAA_ACCOUNT,
                    self.UNAVAILABLE_REASONS.INACTIVE_APP
                ], self.installUnavailableReason);
            };

            self.installButtonVisible = function () {
                return !self.installUnavailableReason || self.installButtonDisabled();
            };

            self.isPublicApp = function () {
                return applicationService.isPublicApp(self.application);
            };

            self.onInstall = function () {
                installMnaService.showConversationPicker(self.application);
            };
            
            function checkIsHipaa() {
                return $q(function (resolve, reject) {
                    api.call(api.myAccount.applications.isHipaa({
                        applicationId: self.application.id,
                        noLoading: true
                    }), function (data) {
                        resolve(data.result);
                    }, function (_, defaultErrorHandler) {
                        defaultErrorHandler();
                        reject();
                    });
                });
            }
    }]
});
